module.exports = __webpack_public_path__ + "static/img/pc_slogan.50bff8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/pc_slogan.png
// module id = NOUI
// module chunks = 1 3